import React from 'react';
import { NavLink } from 'react-router-dom';
import { apiGet, apiPost, apiPut } from '../../../services/apiClient';
import { getRoles } from '../../../services/userRights';
import CheckBoxInput from '../../../controls/checkBoxInput.jsx';
import SelectInput from '../../../controls/selectInput.jsx';
import TextInput from '../../../controls/textInput.jsx';
import AutoCompleteTextInput from '../../../controls/autoCompleteTextInput.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import NotFound from '../../notFound/notFound.jsx';
import NumberInput from "../../../controls/numberInput";
import CreatorSearchDropdown from '../../../components/Dropdowns/CreatorSearchDropdown.jsx';
import DateTimeInput from '../../../controls/dateTimeInput';
import FileSelectionModal from '../../../modals/fileSelectionModal';
import InformationModal from '../../../modals/infoModal';
import ConfirmModal from '../../../modals/confirmModal';

export default class AdminCompaniesForm extends React.Component {
    constructor(args) {
        super(args);

        let companyId = this.props.match.params.id;
        this.state = {
            id: companyId ? companyId : 0,
            busyCount: 0,
            lastResponseError: null,
            carriers: [],
            clientManagers: [],
            companiesUS: [],
            contractStatuses: [],
            holdingCompanies: [],
            files: [],
            errors: {},
            company: {}
        };

        this.infoModal = null;
        this.confirmModal = null;
        this.fileSelectionModal = null;

        this.initCompanyData();
    }

    initCompanyData() {
        const company = {
            name: "",
            inn: "",
            carrierId: null,
            isInsuranceRequired: false,
            useIncomingParcels: false,
            feeUsingYourCarrier: null,
            createByManagerCost: 100,
            companyUsId: null,
            carriers: [],
            clientManagers: [],
            holdingCompanies: [],
            contractStatus: '0',
            contractExpireDate: null,
            isOpenEndedContract: false,
            defermentDaysCount: null,
            isDefermentWorkDays: 'n',
            creator: ""
        };
        this.setState({ company: company });
    }

    componentDidMount() {
        this.reload();
    }

    componentWillReceiveProps(newProps) {
        let companyId = newProps.match.params.id;
        this.setState({ id: companyId ? companyId : 0 }, () => {
            if (this.state.id > 0) {
                this.reloadCompanyData();
            } else {
                this.initCompanyData();
            }
        });
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    reloadFiles() {
        this.updateBusyCount(1);
        apiGet("admin/companies/" + this.state.id + "/files")
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.files = data.entries || [];
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });
    }

    reload() {
        this.updateBusyCount(1);
        apiGet('ref/companiesus/list')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.companiesUS = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('admin/companies/ref/allcarriers')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.carriers = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiGet('admin/companies/ref/allClientManagers')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.clientManagers = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.updateBusyCount(1);
        apiPost('admin/companies/ref/contractStatuses')
            .then(data => {
                this.updateBusyCount(-1);
                this.setState((prevState, props) => {
                    prevState.contractStatuses = data.entries.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                    return prevState;
                });
            })
            .catch(err => {
                this.updateBusyCount(-1);
            });

        this.reloadFiles();
        this.reloadCompanyData();
    }

    reloadCompanyData() {
        if (this.state.id == 0) {
            this.initCompanyData();
        }
        else {
            //edit
            this.updateBusyCount(1);
            apiGet('admin/companies/' + this.state.id)
                .then(data => {
                    this.updateBusyCount(-1);
                    data.name = data.name ? data.name : "";
                    data.carriers = data.selectedCarriers.map(entry => entry.id);                    
                    data.comment = data.comment;
                    data.creator = data.creator || "";
                    data.contractStatus = data.contractStatus;
                    data.isDefermentWorkDays = data.isDefermentWorkDays ? 'y' : 'n';
                    this.setState((prevState, props) => {
                        prevState.company = data;
                        prevState.holdingCompanies = data.holdingCompanies.map((entry, ind, array) => { return { value: entry.id, label: entry.name }; });
                        return prevState;
                    });
                })
                .catch(err => {
                    this.updateBusyCount(-1);
                    if (err.status > 401) {
                        this.setState({ lastResponseError: err.status });
                    }
                });
        }
    }

    save() {
        let errors = this.validateForm();
        if (errors) {
            this.setErrors(errors);
        } else {
            var companyData = {
                id: this.state.id,
                name: this.state.company.name,
                inn: this.state.company.inn,
                kpp: this.state.company.kpp,
                comment: this.state.company.comment,
                companyUsId: this.state.company.companyUsId,
                clientManagerId: this.state.company.clientManagerId,
                isInsuranceRequired: this.state.company.isInsuranceRequired,
                useIncomingParcels: this.state.company.useIncomingParcels,
                selectedCarriers: this.state.company.carriers,
                feeUsingYourCarrier: this.state.company.feeUsingYourCarrier,
                createByManagerCost: this.state.company.createByManagerCost,
                contractStatus: this.state.company.contractStatus,
                contractExpireDate: this.state.company.contractExpireDate,
                isOpenEndedContract: this.state.company.isOpenEndedContract,
                defermentDaysCount: this.state.company.defermentDaysCount,
                isDefermentWorkDays: this.state.company.isDefermentWorkDays === 'y',
                creator: this.state.company.creator
            };

            var applyMethod = null;
            if (this.state.id > 0) {
                applyMethod = apiPost('admin/companies/' + this.state.id, companyData);
            } else {
                applyMethod = apiPut('admin/companies/new', companyData);
            }

            applyMethod
                .then(() => {
                    this.backToList();
                })
                .catch(errors => {
                    this.setErrors(errors.messages);
                });
        }
    }

    uploadNewFile() {
        let title = 'Загрузка документа';
        this.fileSelectionModal.open(title)
            .then(file => {
                let data = new FormData();
                data.append('file', file);
                this.updateBusyCount(1);
                apiPost("admin/companies/" + this.state.id + "/files/upload", data)
                    .then(() => {
                        this.updateBusyCount(-1);
                        this.reloadFiles();
                    })
                    .catch(err => {
                        this.updateBusyCount(-1);
                        if (err.message) {
                            this.infoModal.open(title, err.message);
                        }
                    });
            })
            .catch(() => { });
    }

    setErrors(errors) {
        this.setState({ errors: errors });
    }

    replaceEmptyString(str) {
        if (this.isEmptyString(str)) {
            return null;
        } else {
            return str;
        }
    }

    validateForm() {
        var result = null;

        if (this.isEmptyString(this.state.company.name)) {
            result = {};
            result.name = "Юр.лицо клиента является обязательным полем";
        }

        if (!this.state.company.companyUsId) {
            result = result ? result : {};
            result.companyUsId = "Юр. лицо US является обязательным полем";
        }

        if (this.isEmptyString(this.state.company.inn)) {
            result = result ? result : {};
            result.inn = "ИНН является обязательным полем";
        }

        if (this.isEmptyString('' + this.state.company.defermentDaysCount)) {
            result = result ? result : {};
            result.defermentDaysCount = "Количество дней отсрочки является обязательным полем";
        }

        return result;
    }

    isEmptyString(str) {
        return str === null || str === undefined || ("" + str).length === 0;
    }

    backToList() {
        this.props.history.push('/admin/companies/list');
    }

    handleTextInputChange(name, value) {
        let company = this.state.company;
        company[name] = value;
        this.setState({
            company: company
        });
    }

    handleContractStatusChange(selection) {
        let company = { ...this.state.company };
        company.contractStatus = selection ? selection.value : null;
        this.setState({ company: company });
    }

    handleDefermentWorkDaysChange(selection) {
        let company = { ...this.state.company };
        company.isDefermentWorkDays = selection ? selection.value : null;
        this.setState({ company: company });
    }

    handleCompanyUSChange(selection) {
        let company = { ...this.state.company };
        company.companyUsId = selection ? selection.value : null;
        this.setState({ company: company });
    }

    handleClientManagerChange(selection) {
        let company = { ...this.state.company };
        company.clientManagerId = selection ? selection.value : null;
        this.setState({ company: company });
    }

    handleCarriersChange(selection) {
        let company = { ...this.state.company };
        if (selection) {
            company.carriers = selection.map((entry, ind, array) => entry.value);
        } else {
            company.carriers = [];
        }
        this.setState({ company: company });
    }

    handleCreatorChange(value) {
        let company = { ...this.state.company };
        company.creator = value || "";
        this.setState({ company: company });
    }

    handleCreatorItemSelect(item) {
        if (item && item.login) {
            let company = { ...this.state.company };
            company.creator = item.login;
            this.setState({ company: company });
        }
    }

    loadUsersByLogin(searchText, sessionKey) {
        if (!searchText || searchText.length < 2) {
            return Promise.resolve([]);
        }
        return apiPost('admin/companies/ref/users/search', { searchText: searchText })
            .then(data => {
                if (data && data.entries) {
                    return data.entries.map(entry => ({
                        login: entry.login,
                        fullName: entry.fullName,
                        display: `${entry.login}${entry.fullName ? ' - ' + entry.fullName : ''}`
                    }));
                }
                return [];
            })
            .catch(err => {
                console.error('Failed to search users:', err);
                return [];
            });
    }

    deleteFile(fileId, fileName) {
        this.confirmModal.open('Удаление документа', `Вы действительно хотите удалить файл '${fileName}'? Это действие нельзя будет отменить.`)
            .then(() => {
                this.updateBusyCount(1);
                apiPost("admin/companies/" + this.state.id + "/files/" + fileId + "/delete")
                    .then(() => {
                        this.updateBusyCount(-1);
                        this.reloadFiles();
                    })
                    .catch(() => {
                        this.updateBusyCount(-1);
                    });
            });
    }

    getFilesList() {
        return this.state.files.map((file) => {
            let fileUrl = getApiBaseUrl() + "admin/companies/" + this.state.id + "/files/" + file.id + "/download";
            return (
                <div className="row files-row">
                    <div className="col-xs-12">
                        <i className="fa fa-paperclip files-row-icon"></i>
                        <a href={fileUrl}>{file.fileName}</a>
                        <i className="fa fa-trash-o files-remove-btn files-row-icon" onClick={() => this.deleteFile(file.id, file.fileName)}></i>
                    </div>
                </div>
            );
        })
    }

    render() {
        let roles = getRoles();
        let hasAccess = roles.includes('Admin') || roles.includes('GlobalAdmin') || roles.includes('Financial');
        if (!hasAccess || this.state.lastResponseError === 403) {
            return <Forbidden />;
        }
        if (this.state.lastResponseError === 404) {
            return <NotFound />;
        }

        let isNew = this.state.id < 1;
        let isBusy = this.state.busyCount > 0;
        let isCoordinator = roles.includes('Coordinator');
        let isAdmin = roles.includes('Admin');
        let isGlobalAdmin = roles.includes('GlobalAdmin');
        // Поле видимо для КМ, Админ PoEx, Админ глобальный
        let showCreatorField = isCoordinator || isAdmin || isGlobalAdmin;
        // Редактирование разрешено только для Админ глобальный
        let canEditCreator = isGlobalAdmin;
        let header = isNew
            ? (
                <section className="content-header">
                    <h1>Новое юр. лицо</h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li><NavLink to="/admin/companies/list">Юр. лица клиентов</NavLink></li>
                        <li className="active">Новое юр. лицо</li>
                    </ol>
                </section>
            )
            : (
                <section className="content-header">
                    <h1>Юр.лицо {this.state.company.name}</h1>
                    <ol className="breadcrumb">
                        <li><a><i className="fa fa-cogs"></i> Администрирование</a></li>
                        <li><NavLink to="/admin/companies/list">Юр. лица клиентов</NavLink></li>
                        <li className="active">{this.state.company.name}</li>
                    </ol>
                </section>
            );
        let passwordPlaceholder = isNew ? "" : "Для смены пароля укажите новый...";
        return (
            <div>
                {header}
                <section className="content">
                    <div className="row">
                        <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                            <div className="box box-primary">
                                <div className="box-body">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className={"form-group" + (this.state.errors.inn ? " has-error" : "")}>
                                                <label htmlFor="inputInn">ИНН<span className="text-red">*</span></label>
                                                <TextInput id="inputInn"
                                                    title={this.state.errors.inn}
                                                    value={this.state.company.inn}
                                                    onChange={value => this.handleTextInputChange("inn", value)}
                                                    disabled={isBusy || this.state.id}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.name ? " has-error" : "")}>
                                                <label htmlFor="inputName">Юр. лицо клиента<span className="text-red">*</span></label>
                                                <TextInput id="inputName"
                                                    title={this.state.errors.name}
                                                    value={this.state.company.name}
                                                    onChange={value => this.handleTextInputChange("name", value)}
                                                    disabled={isBusy || this.state.id}
                                                />
                                            </div>
                                            <div className={"form-group" + (this.state.errors.comment ? " has-error" : "")}>
                                                <label htmlFor="inputName">Комментарий</label>
                                                <TextInput id="inputName"
                                                    title={this.state.errors.comment}
                                                    value={this.state.company.comment}
                                                    onChange={value => this.handleTextInputChange("comment", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.feeUsingYourCarrier ? " has-error" : "")}>
                                                <label htmlFor="feeUsingYourCarrier">Плата за пользование своим перевозчиком, р. с НДС</label>
                                                <NumberInput id="feeUsingYourCarrier"
                                                    title={this.state.errors.feeUsingYourCarrier}
                                                    value={this.state.company.feeUsingYourCarrier}
                                                    onChange={value => this.handleTextInputChange("feeUsingYourCarrier", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.createByManagerCost ? " has-error" : "")}>
                                                <label htmlFor="createByManagerCost">Стоимость создания заказа клиентским менеджером р. с НДС</label>
                                                <NumberInput id="createByManagerCost"
                                                    title={this.state.errors.createByManagerCost}
                                                    value={this.state.company.createByManagerCost}
                                                    onChange={value => this.handleTextInputChange("createByManagerCost", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.defermentDaysCount ? " has-error" : "")}>
                                                <label htmlFor="defermentDaysCount">Дней отсрочки платежа от даты счёта<span className="text-red">*</span></label>
                                                <div style={{ display: 'flex' }}>
                                                    <div style={{ flex: '1' }}>
                                                        <NumberInput id="defermentDaysCount"
                                                            title={this.state.errors.defermentDaysCount}
                                                            value={this.state.company.defermentDaysCount}
                                                            onChange={value => this.handleTextInputChange("defermentDaysCount", value)}
                                                            disabled={isBusy}
                                                        />
                                                    </div>
                                                    <div style={{ width: '200px', flexShrink: 0, flexGrow: 0 }}>
                                                        <SelectInput id="isDefermentWorkDays"
                                                            options={[
                                                                { value: 'y', label: 'рабочих дней' },
                                                                { value: 'n', label: 'календарных дней' }
                                                            ]}
                                                            value={this.state.company.isDefermentWorkDays}
                                                            title={this.state.errors.isDefermentWorkDays}
                                                            onChange={e => this.handleDefermentWorkDaysChange(e)}
                                                            disabled={isBusy}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {showCreatorField && (
                                                <div className={"form-group" + (this.state.errors.creator ? " has-error" : "")}>
                                                    <label htmlFor="inputCreator">Инициатор создания ЮЛ</label>
                                                    {canEditCreator ? (
                                                        <CreatorSearchDropdown
                                                            name="creator"
                                                            value={this.state.company.creator}
                                                            onChange={(name, value) => this.handleCreatorChange(value)}
                                                            disabled={isBusy || !canEditCreator}
                                                            placeholder="Введите логин для поиска"
                                                            error={this.state.errors.creator}
                                                        />
                                                    ) : (
                                                        <TextInput
                                                            id="inputCreator"
                                                            title={this.state.errors.creator}
                                                            value={this.state.company.creator}
                                                            disabled={true}
                                                        />
                                                    )}
                                                </div>
                                            )}  
                                        </div>
                                        <div className="col-sm-6">
                                            {this.state.id &&
                                                <div className="form-group">
                                                    <label htmlFor="holdingCompanies">Холдинг</label>
                                                    <SelectInput id="holdingCompanies"
                                                        options={this.state.holdingCompanies} multi
                                                        value={this.state.holdingCompanies}
                                                        disabled
                                                    />
                                                </div>
                                            }

                                            <div className={"form-group" + (this.state.errors.companyUsId ? " has-error" : "")}>
                                                <label htmlFor="selectCompanyUS">Юр. лицо US<span className="text-red">*</span></label>
                                                <SelectInput id="selectCompanyUS"
                                                    options={this.state.companiesUS}
                                                    value={this.state.company.companyUsId}
                                                    title={this.state.errors.companyUsId}
                                                    onChange={e => this.handleCompanyUSChange(e)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.clientManagerId ? " has-error" : "")}>
                                                <label htmlFor="selectClientManager">Клиентский менеджер</label>
                                                <SelectInput id="selectClientManager"
                                                    options={this.state.clientManagers}
                                                    value={this.state.company.clientManagerId}
                                                    title={this.state.errors.clientManagerId}
                                                    onChange={e => this.handleClientManagerChange(e)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.carriers ? " has-error" : "")}>
                                                <label htmlFor="selectCarrier">Транспортные компании</label>
                                                <SelectInput id="selectCarrier"
                                                    options={this.state.carriers} multi
                                                    value={this.state.company.carriers}
                                                    title={this.state.errors.carriers}
                                                    onChange={e => this.handleCarriersChange(e)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.contractStatus ? " has-error" : "")}>
                                                <label htmlFor="contractStatus">Статус договора</label>
                                                <SelectInput id="contractStatus"
                                                    options={this.state.contractStatuses}
                                                    value={this.state.company.contractStatus}
                                                    title={this.state.errors.contractStatus}
                                                    onChange={e => this.handleContractStatusChange(e)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.contractExpireDate ? " has-error" : "")}>
                                                <label htmlFor="contractExpireDate">Срок действия договора</label>
                                                <DateTimeInput id="contractExpireDate"
                                                    enableTime={false}
                                                    title={this.state.errors.contractExpireDate}
                                                    value={this.state.company.contractExpireDate}
                                                    onChange={value => this.handleTextInputChange("contractExpireDate", value)}
                                                    disabled={isBusy}
                                                />
                                            </div>

                                            <div className={"form-group" + (this.state.errors.isOpenEndedContract ? " has-error" : "")}>
                                                <div className="checkbox">
                                                    <label>
                                                        <CheckBoxInput id="inputIsOpenEndedContract"
                                                            title={this.state.errors.isOpenEndedContract}
                                                            checked={this.state.company.isOpenEndedContract}
                                                            onChange={value => this.handleTextInputChange("isOpenEndedContract", value)}
                                                            disabled={isBusy}
                                                        />
                                                        Бессрочный договор
                                                    </label>
                                                </div>
                                            </div>

                                            <div className={"form-group" + (this.state.errors.isInsuranceRequired ? " has-error" : "")}>
                                                <div className="checkbox">
                                                    <label>
                                                        <CheckBoxInput id="inputIsInsuranceRequired"
                                                            title={this.state.errors.isInsuranceRequired}
                                                            checked={this.state.company.isInsuranceRequired}
                                                            onChange={value => this.handleTextInputChange("isInsuranceRequired", value)}
                                                            disabled={isBusy}
                                                        />
                                                        Страхование обязательно
                                                    </label>
                                                </div>
                                            </div>

                                            <div className={"form-group" + (this.state.errors.useIncomingParcels ? " has-error" : "")}>
                                                <div className="checkbox">
                                                    <label>
                                                        <CheckBoxInput id="inputUseIncomingParcels"
                                                            title={this.state.errors.useIncomingParcels}
                                                            checked={this.state.company.useIncomingParcels}
                                                            onChange={value => this.handleTextInputChange("useIncomingParcels", value)}
                                                            disabled={isBusy}
                                                        />
                                                        Учет входящих отправлений
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-footer files-list-box">
                                    <h3>Документы</h3>
                                    {this.getFilesList()}
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <button className="btn btn-flat btn-primary" onClick={() => this.uploadNewFile()} disabled={isBusy}>
                                                <i className="fa fa-plus" style={{ marginRight: '4px' }} ></i>
                                                Загрузить файл
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="box-footer">
                                    <button className="btn btn-flat btn-default" onClick={() => this.backToList()} disabled={isBusy}>
                                        Отмена
                                    </button>
                                    <button className="btn btn-flat btn-primary pull-right" onClick={() => this.save()} disabled={isBusy}>
                                        Сохранить
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <InformationModal ref={modal => this.infoModal = modal} />
                <ConfirmModal ref={modal => this.confirmModal = modal} />
                <FileSelectionModal ref={modal => this.fileSelectionModal = modal} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/admin/companies/companiesForm.jsx